import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import moment from "moment";
import cx from "classnames";
//Components
import AreaMenu, { Area, Menu } from "Components/AreaMenu";
import { Input, Select, Button } from '@gpstrackit/react-controls';
import PanelLabel from "./.components/PanelLabel";
import { Box } from "@mui/material";

//Styles
import './index.scss';

const SliderRangeTime = ({
    date,
    selectedTime,
    onApply,
    timezone,
    label
}) => {

    //Local States
    const [error, setError] = useState(false);
    const [timer, setTimer] = useState();

    const { messages } = useIntl();

    //Ref
    const areaMenuRef = useRef();

    useEffect(() => {
        const formattedDate = moment(selectedTime).tz(timezone || 'UTC');
        const hours = formattedDate.hours();
        const isPm = hours >= 12;
        const formattedHours = isPm ? hours - 12 : hours;
        const formattedMinutes = formattedDate.minutes().toString().padStart(2, '0');
        const formattedSeconds = formattedDate.seconds().toString().padStart(2, '0');
        const ampm = isPm ? 'pm' : 'am';

        setTimer({
            hour: formattedHours < 10 ? `0${formattedHours}` : formattedHours,
            min: formattedMinutes,
            sec: formattedSeconds,
            ampm,
        });
    }, [date, selectedTime, timezone]);

    const setApply = () => {
        if (!timer.hour || !timer.min || !timer.sec) {
            setError(true)
            return;
        }
        setError(false)
        const hour = parseInt(timer.hour, 10);
        const minute = parseInt(timer.min, 10);
        const second = parseInt(timer.sec, 10);
        const isPm = timer.ampm === 'pm';

        const momentDate = moment(selectedTime);
        momentDate.hour(isPm && hour < 12 ? hour + 12 : hour);
        momentDate.minute(minute);
        momentDate.second(second);

        onApply(momentDate);
    };
    return (
        <>
            {date ? (
                <AreaMenu className='datepicker_container--areamenu' id={"ssss"} ref={areaMenuRef}>
                    <Area>
                        <PanelLabel
                            message={messages['create_clip_start_date']}
                            value={date}
                            row
                        />
                    </Area>
                    <Menu style={{ width: "450px" }}>
                        <Box style={{ display: 'flex', padding: error ? '10px 10px 0 10px' : 10 }}>
                            <Box style={{ width: 80 }}>
                                <Input
                                    label={messages['common_hour']}
                                    onlyPositive
                                    preventOnChange
                                    value={timer?.hour}
                                    onChange={(val) => {
                                        if (val.length > 2) return
                                        setTimer({ ...timer, hour: val })
                                    }}
                                    style={{ width: 15 }}
                                    type='number'
                                    min={0}
                                    max={12}
                                    className={cx("slider-select-time", (error && "form-control-invalid"))}
                                />

                            </Box>
                            <Box style={{ display: 'flex', alignItems: 'center', margin: '27px 5px 0px -5px', fontWeight: 600 }}>
                                :
                            </Box>
                            <Box style={{ width: 80 }}>
                                <Input
                                    label={messages['common_mins']}
                                    onlyPositive
                                    preventOnChange
                                    value={timer?.min}
                                    onChange={(val) => {
                                        if (val.length > 2) return
                                        setTimer({ ...timer, min: val })
                                    }}
                                    style={{ width: 15 }}
                                    type='number'
                                    min={0}
                                    max={59}
                                    className={cx("slider-select-time", (error && "form-control-invalid"))}
                                />
                            </Box>
                            <Box style={{ display: 'flex', alignItems: 'center', margin: '27px 5px 0px -5px', fontWeight: 600 }}>
                                :
                            </Box>
                            <Box style={{ width: 80 }}>
                                <Input
                                    label={messages['common_seconds']}
                                    onlyPositive
                                    preventOnChange
                                    value={timer?.sec}
                                    onChange={(val) => {
                                        if (val.length > 2) return
                                        setTimer({ ...timer, sec: val })
                                    }}
                                    style={{ width: 15 }}
                                    type='number'
                                    min={0}
                                    max={59}
                                    className={cx("slider-select-time", (error && "form-control-invalid"))}
                                />
                            </Box>
                            <Box style={{ width: 80 }}>
                                <Select
                                    id="type"
                                    name="type"
                                    value={{ value: timer?.ampm, label: timer?.ampm }}
                                    label="am/pm"
                                    placeholder="am/pm"
                                    onChange={(value) => setTimer({ ...timer, ampm: value.value })}
                                    options={[{ value: 'am', label: 'am' }, { value: 'pm', label: 'pm' }]}
                                    textField="label"
                                    valueField="value"
                                />
                            </Box>
                            <Box style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: 25,
                                width: 102
                            }}>
                                <Button
                                    className="btn-blue"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setApply()
                                    }}
                                    style={{ marginLeft: 5, width: '100%' }}
                                >
                                    {messages['common_set']}
                                </Button>
                            </Box>
                        </Box>
                        {
                            error &&
                            <small class="text-danger" style={{ marginLeft: 10, marginBottom: 10 }}>{messages['common_hour_no_valid']}</small>
                        }
                    </Menu>
                </AreaMenu>
            ) : (
                <PanelLabel
                    message={messages['create_clip_no_data']}
                    value='-----'
                />
            )}
        </>
    );

}
export default SliderRangeTime